<div class="survey-question">
  <label class="question-label">
    <div class="question-header">
      <span class="question-number">{{ questionNumber }}</span>
      <span class="question-text" [innerHTML]="question.question | safeHtml"></span>
      @if (question.isRequired) {
      <span class="required">Required</span>
      }
    </div>
    @if(question.metadata?.instructions) {
    <span class="instructions">{{question.metadata?.instructions}}</span>
    } @else {
    <span class="instructions">{{getDefaultInstructionByType(question.type)}}</span>
    }
  </label>


  <div class="option-container">
    @if (question.type === 'boolean') {
    <div class="radio-button-group">
      <input type="radio" value="true" name="{{ 'question-' + questionNumber }}"
        (change)="onValueChanged(question.questionId, 'true')" [checked]="savedValue === 'true'" />
      <label>True</label>
    </div>
    <div class="radio-button-group">
      <input type="radio" value="false" name="{{ 'question-' + questionNumber }}"
        (change)="onValueChanged(question.questionId, 'false')" [checked]="savedValue === 'false'" />
      <label>False</label>
    </div>
    }

    @if (question.type === 'yesno') {
    <div class="radio-button-group">
      <input type="radio" value="yes" name="{{ 'question-' + questionNumber }}"
        (change)="onValueChanged(question.questionId, 'yes')" [checked]="savedValue === 'yes'" />
      <label>Yes</label>
    </div>
    <div class="radio-button-group">
      <input type="radio" value="no" name="{{ 'question-' + questionNumber }}"
        (change)="onValueChanged(question.questionId, 'no')" [checked]="savedValue === 'no'" />
      <label>No</label>
    </div>
    }

    @if (question.type === 'single-choose') {
    <div class="single-choose-option">
      @for (option of question.options; track i; let i = $index) {
      <div class="multiple-option">
        <input type="radio" [value]="option" class="option-input" name="{{ 'question-' + questionNumber }}"
          (change)="onValueChanged(question.questionId, option)" [checked]="savedValue === option" />
        <span class="option-text ml-2">{{ option }}</span>
      </div>
      }
    </div>
    }

    @if (question.type === 'multiple-choose') {
    <div class="multiple-choose-option">
      @for (option of question.options; track i; let i = $index) {
      <div class="multiple-option">
        <input type="checkbox" [value]="option" class="option-input" name="{{ 'question-' + questionNumber }}" (change)="
                onMultipleChooseValueChanged(
                  question.questionId,
                  option,
                  $event
                )
              " [checked]="savedValue && savedValue.includes(option)" />
        <span class="option-text ml-2">{{ option }}</span>
      </div>
      }
    </div>
    }
    @if (question.type === 'ranking') {
    <div class="ranking">
      @for(option of question.options; track option) {
      <div class="ranking-option-item">
        <div class="ranking-buttons">
          @if (getRankingForOption(option)) {
          <button type="button" class="rank-button filled">
            {{ getRankingForOption(option) }}
          </button>
          } @else {
          <button type="button" (click)="rankOption(option)" class="rank-button empty">
            {{ getRankingForOption(option) || '' }}
          </button>
          }
        </div>
        <div class="option-text" [ngClass]="{'bold': getRankingForOption(option)}">
          {{ option }}
        </div>
      </div>
      }
      <div class="clear-ranking">
        <button type="button" (click)="clearRanking()" class="clear-button">Reset</button>
      </div>
    </div>

    }

    @if (question.type === 'satisfactory-scale') {
    <div class="satisfactory-scale-option">
      <div class="scale-wrapper">
        @for (
        i of getRange();
        track n;
        let n = $index
        ) {
        <div class="scale-option">
          <input type="radio" [value]="n + 1" class="option-input" name="{{ 'question-' + questionNumber }}" (change)="
                  onValueChanged(question.questionId, (n + 1).toString())
                " [checked]="savedValue === (n + 1).toString()" />
          <span class="option-text">{{ n + 1 }}</span>
        </div>
        }
      </div>
    </div>
    }

    @if (question.type === 'free-text') {

    @if(['multi-lines', 'alphanumeric'].includes(question.metadata.textDataType) || !question.metadata.textDataType) {
    <div class="free-text-option">
      <textarea class="free-text-area" (input)="handleTextareaChange($event)" [(value)]="savedValue"
        [maxLength]="question.metadata.textLimit || 4000" [rows]="question.metadata.textLinesLimit || 3"></textarea>
      <div>Limit:{{savedValue.length || 0}}/{{ question.metadata.textLimit }}</div>
    </div>
    }
    @else if(question.metadata.textDataType === 'numeric') {
    <div class="relative flex items-center w-full">
      <input type="number" [maxLength]="question.metadata.maxLength || 50" [max]="question.metadata.textLimit || 50"
        [value]="savedValue" (input)="handleTextareaChange($event)"
        class="flex-1 mt-1 block w-full pl-3 pr-10 py-2 text-base border border-gray-300 bg-white focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md">
    </div>
    }
    @else if (question.metadata.textDataType === 'email') {
    <input type="email" name="email" [maxLength]="emailMaxLength" [(ngModel)]="savedValue" #emailModel="ngModel"
      appEmailValidator [ngModelOptions]="{ standalone: true }" (input)="handleTextareaChange($event)"
      class="flex-1 mt-1 block w-full pl-10 pr-10 py-2 text-base border border-gray-300 bg-white focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md">
      @if (emailModel.errors?.['invalidEmail']) {
      <div class="text-red-500 text-sm">Please enter a valid email address.</div>
      }
    }
    @else if(question.metadata.textDataType === 'url') {
    <div class="relative flex items-center w-full">
      <lucide-icon name="link"
        class="absolute inset-y-0 w-[30px] h-[30px] left-0 pl-3 mr-2 mt-[4px] text-gray-400"></lucide-icon>
      <input type="url" [maxLength]="question.metadata.textLimit || 50" [(value)]="savedValue"
        (input)="handleTextareaChange($event)"
        class="flex-1 mt-1 block w-full pl-10 pr-10 py-2 text-base border border-gray-300 bg-white focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md">
      <div>Limit:{{savedValue.length || 0}}/{{ question.metadata.textLimit }}</div>
    </div>
    }
    @else if(question.metadata.textDataType === 'phone-number') {
    <div class="relative flex items-center w-full">
      <lucide-icon name="phone"
        class="absolute inset-y-0 w-[30px] h-[30px] left-0 pl-3 mr-2 mt-[4px] text-gray-400"></lucide-icon>
      <input type="text" [mask]="'(000) 000-0000'" [maxLength]="question.metadata.textLimit || 50" [value]="savedValue"
        (input)="handleTextareaChange($event)"
        class="flex-1 mt-1 block w-full pl-10 pr-10 py-2 text-base border border-gray-300 bg-white focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md">
    </div>
    }
    }
  </div>



  @if (question.type === 'single-image') {
  <div class="flex flex-wrap gap-4 justify-center items-center" *ngIf="isAssetLoaded">
    <div *ngFor="let option of question.options; let i = index" class="flex flex-col items-center cursor-pointer">
      <label [attr.for]="'question-' + questionNumber + '-' + i" class="max-w-xs px-2">
        <img [src]="getSrc(question, i)"
          class="object-contain h-48 w-full rounded-md transition-shadow duration-300 ease-in-out"
          [ngClass]="{'border-shadow': savedValue === option}" alt="{{option}}">
      </label>
      <div class="flex items-center mt-2">
        <input type="radio" [id]="'question-' + questionNumber + '-' + i" [value]="option" class="option-input"
          name="{{ 'question-' + questionNumber }}" [checked]="savedValue === option" />
        <label [attr.for]="'question-' + questionNumber + '-' + i" class="option-text ml-2">{{ option }}</label>
      </div>
    </div>
    <!-- (change)="onValueChanged(question.questionId, option)" -->
  </div>
  }


  @if (question.metadata?.useFollowUpQuestion){
  <div class="followup-container">
    <label class="question-followup-label">{{ question.metadata?.followUpQuestionText }}</label>
    <div class="free-text-option">
      <textarea class="free-text-area" (input)="handleFollowUpTextareaChange($event)" [(value)]="savedFolloupValue"
        [maxLength]="4000"></textarea>
      <div>Limit:{{savedFolloupValue.length || 0}}/4000</div>
    </div>
  </div>
  }
</div>